import React from 'react';
import ForgotPasswordForm from '../../components/auth/forgot-password-form';

const ForgotPassword: React.FunctionComponent<any> = () => {
    return <ForgotPasswordForm />;
};
export default ForgotPassword;
